var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___VnhYRG",
  "cU": "UserArea.module__userAreaContainer___VnhYRG",
  "jC": "UserArea.module__popoutContainer___VnhYRG",
  "oT": "UserArea.module__voiceConnectionWrapper___VnhYRG",
  "eF": "UserArea.module__userInfo___VnhYRG",
  "vu": "UserArea.module__active___VnhYRG",
  "N6": "UserArea.module__userInfoText___VnhYRG",
  "nT": "UserArea.module__userName___VnhYRG",
  "ag": "UserArea.module__userStatus___VnhYRG",
  "uh": "UserArea.module__userStatusLabel___VnhYRG" + " " + "UserArea.module__userStatus___VnhYRG",
  "XW": "UserArea.module__userCustomStatus___VnhYRG" + " " + "UserArea.module__userStatus___VnhYRG",
  "oM": "UserArea.module__hoverRoll___VnhYRG",
  "n6": "UserArea.module__defaultState___VnhYRG",
  "yo": "UserArea.module__hovered___VnhYRG",
  "EE": "UserArea.module__forceHover___VnhYRG",
  "gO": "UserArea.module__controlsContainer___VnhYRG",
  "uH": "UserArea.module__controlButton___VnhYRG",
  "DY": "UserArea.module__contextMenuHover___VnhYRG",
  "r9": "UserArea.module__disabled___VnhYRG",
  "pd": "UserArea.module__controlIcon___VnhYRG",
};

module.exports = exports;
